import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react';
import { Control, Controller } from 'react-hook-form';

import {
  type Condition,
  CONDITIONS,
  createConditionName,
} from 'types/notification';
import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';

type Props = {
  control: Control<NotificationFormFields>;
  handleChangeCondition: (condition: Condition) => void;
};

/**
 * 配信対象顧客のラジオボタンのフォームです。
 * Chakra の RadioGroup は制御コンポーネントなので、react-hook-form の register ではなく
 * Controller と control でフォーム化しています。
 */
export const ConditionForm: FC<Props> = ({
  control,
  handleChangeCondition,
}) => (
  <FormControl>
    <FormLabel>配信対象顧客</FormLabel>
    <Controller
      control={control}
      name="condition"
      render={({ field: { onChange, value } }) => (
        <RadioGroup
          defaultValue={value}
          onChange={(nextValue: string) => {
            onChange(nextValue);
            handleChangeCondition(nextValue as Condition);
          }}
        >
          <Stack>
            <Radio value={CONDITIONS.ALL}>
              {createConditionName(CONDITIONS.ALL)}
            </Radio>
            <Radio value={CONDITIONS.INCLUDE}>
              {createConditionName(CONDITIONS.INCLUDE)}
            </Radio>
            <Radio value={CONDITIONS.EXCLUDE}>
              {createConditionName(CONDITIONS.EXCLUDE)}
            </Radio>
          </Stack>
        </RadioGroup>
      )}
    />
  </FormControl>
);
